import { Button, InnoTable } from "@InnoUI/";
import SC from "./style";
import theme from "@theme/";
import { useEffect, useState } from "react";
import AddEditNewUser from "./AddEditNewUser";
import AssignUser from "./AssignUser";
import { apiGet, apiPost } from "api/callApi";
import { useSearchParams } from "react-router-dom";
import InnoIcons from "@InnoIcons/";
import DeleteComponent from "views/AdminSettings/DeleteComponent";
import { useSelector } from "react-redux";
import { tenantData } from "utils/lookUpTable";
import { decryptCrypto, showAlert } from "utils/helper";

const ContactInformation = (props) => {
  const { hideButtons } = props;
  const [data, setData] = useState([]);
  const [openModalView, setOpenModalView] = useState(false);
  const [openAssignModalView, setOpenAssignModalView] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const [rowData, setRowData] = useState();
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [fieldId, setFieldId] = useState();
  const [roleId, setRoleId] = useState();

  const currentUser = useSelector((state) => state?.authdata?.data || {});
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || []
  );

  const getContactInformationData = async (id) => {
    try {
      const response = await apiGet(
        `/v1/addressbook/${projectId}/${type}?roleIds=${id}`,
        false
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  const fetchAllTenantData = async () => {
    const promises = tenantData.map((tenant) =>
      getContactInformationData(tenant.id)
    );

    const results = await Promise.all(promises);
    const combinedData = tenantData.map((tenant, index) => ({
      ...tenant,
      data: results[index],
    }));
    setData(combinedData);
  };

  useEffect(() => {
    fetchAllTenantData();
  }, []);

  const handleDelete = async (userId) => {
    try {
      const body = {
        users: [userId],
      };
      const response = await apiPost(
        `/v1/occupant/contactinformation/${userId}/${currentOccupant.id}`
      );
      showAlert({
        title: "Success",
        text: response.message,
        icon: "success",
      });
      fetchAllTenantData();
      setOpenDeleteView(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleDeleteOpenModal = (record) => {
    setFieldId(record.id);
    setRowData(record);
    setOpenDeleteView(true);
  };

  const handleNewUser = (id) => {
    setRoleId(id);
    setOpenModalView(true);
    setRowData(null);
    setIsEditing(false);
  };

  const handleAssignUser = (id) => {
    setRoleId(id);
    setOpenAssignModalView(true);
  };
  const handleEditUser = (record) => {
    setOpenModalView(true);
    setIsEditing(true);
    setRowData(record);
  };

  const journalColumn = [
    {
      title: "Name",
      width: 300,
      dataIndex: "fullName",
      render(value, record) {
        return <p>{value}</p>;
      },
    },

    {
      title: "Email",
      width: 350,
      dataIndex: "email",
      render(value, record) {
        return <p>{value}</p>;
      },
    },

    {
      title: "Company",
      width: 300,

      dataIndex: "companyName",
      render(value, record) {
        return <p>{value}</p>;
      },
    },
    {
      title: "Cell",
      width: 300,
      dataIndex: "cell",
      render(value, record) {
        return <p>{decryptCrypto(value)}</p>;
      },
    },
  ];

  // Conditionally add the Action column
  if (!hideButtons) {
    journalColumn.push({
      title: "Action",
      width: 100,
      dataIndex: "createdOn",
      render(value, record) {
        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <div
              style={{
                backgroundColor: "#1565C0",
                borderRadius: "3px",
                height: "18px",
                width: "18px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={() => handleEditUser(record)}
            >
              <InnoIcons.EditIcon
                sx={{ fontSize: "12px", color: "white", marginTop: "3px" }}
              />
            </div>
            <div
              style={{
                backgroundColor: "#F44336",
                borderRadius: "3px",
                height: "18px",
                width: "18px",
                textAlign: "center",
                cursor: "pointer",
              }}
              onClick={() => handleDeleteOpenModal(record)}
            >
              <InnoIcons.DeleteIcon
                sx={{ fontSize: "12px", color: "white", marginTop: "3px" }}
              />
            </div>
          </div>
        );
      },
    });
  }

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: false,
    search: false,
    action: false,
    divBorder: false,
    sno: false,
    addDummyData: false,
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          padding: "10px",
        }}
      >
        {data.map((item, index) => (
          <SC.CardContainerStyle
            key={index}
            style={{
              flex: "1 1 calc(40% - 0px)",
              paddingRight: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p style={{ fontWeight: "bold" }}>{item.name}</p>
              {!hideButtons && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  <Button
                    caption={"Assign User"}
                    color={theme.colors.themeColor}
                    fontSize="12px"
                    style={{
                      background: theme.gradient.white,
                      color: theme.colors.themeColor,
                      minWidth: "100px",
                      height: "25px",
                      borderRadius: "3px",
                      border: `1px solid ${theme.colors.themeColor}`,
                    }}
                    onClick={() => handleAssignUser(item.id)}
                  />
                  <Button
                    caption={"Create New User"}
                    color={theme.colors.themeColor}
                    fontSize="12px"
                    style={{
                      background: theme.gradient.white,
                      color: theme.colors.themeColor,
                      minWidth: "100px",
                      height: "25px",
                      borderRadius: "3px",
                      border: `1px solid ${theme.colors.themeColor}`,
                    }}
                    onClick={() => handleNewUser(item.id)}
                  />
                </div>
              )}
            </div>
            <InnoTable
              tableConfig={tableConfig}
              padding={"4px 8px 6px 8px"}
              column={journalColumn}
              data={item.data}
              tableKey={"Journal"}
              searchKeys={["propertyName", "displayTemplateName"]}
              borderleft="none"
              tablepadding="0px"
            />
          </SC.CardContainerStyle>
        ))}
      </div>

      {openModalView && (
        <AddEditNewUser
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          fetchData={fetchAllTenantData}
          userdata={rowData}
          roleId={roleId}
        />
      )}

      {openAssignModalView && (
        <AssignUser
          setOpenAssignModalView={setOpenAssignModalView}
          openAssignModalView={openAssignModalView}
          fetchData={fetchAllTenantData}
          roleId={roleId}
        />
      )}
      {openDeleteView && (
        <DeleteComponent
          title={"Delete User"}
          messageData={`Are you sure you want to Delete this User ${
            rowData?.fullName || ""
          }?`}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => handleDelete(fieldId)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
        />
      )}
    </>
  );
};

export default ContactInformation;
